////////////////////
// Template
////////////////////
const template = /*html*/ `
    <div class="c-cart-items || o-padding -padding-tiny-top -padding-tiny-bottom">
        <!-- Items -->
        <ul v-if='this.cart && this.cart.items && this.cart.items.length' class="c-cart-items_list">
            <cart-item
                v-for="(cartItem, index) in cart.items"
                ref="item"
                :title="cartItem.product_title"
                :variant-id="cartItem.variant_id"
                :quantity="cartItem.quantity"
                :price="cartItem.final_line_price"
                :compare-at-price="cartItem.total_discount"
                :image="cartItem.featured_image.url"
                :selected-options="cartItem.options_with_values"
                :module-instance="moduleInstance"
                :currency-iso-code='currencyIsoCode'
                :currency-symbol='currencySymbol'
                :delete-label="deleteLabel"
                :key="cartItem.key"
                :cartKey="cartItem.key"
                :properties="cartItem.properties"
                :has-token-gated-products="hasTokenGatedProducts"
            />
        </ul>
        <!-- Empty message -->
        <div v-else class="c-cart_empty">
            <p class="c-text -small">
                <slot name="empty-cart"></slot>
            </p>
        </div>
    </div>
`;


////////////////////
// Scripts
////////////////////
export default function VueCart(moduleInstance) {

    Vue.component("cart", {

        template,

        props: {
            currencyIsoCode: {
                type: String,
                required: true
            },
            currencySymbol: {
                type: String,
                required: true
            },
            deleteLabel: {
                type: String,
                default: 'Delete'
            }
        },

        data() {
            return {
                cart: [],
                moduleInstance: moduleInstance
            };
        },

        computed: {
            hasTokenGatedProducts() {
                return this.cart.items && this.cart.items.find(item => item.properties?._isTokenGated) ? true : false
            }
        },

        watch: {
            hasTokenGatedProducts: {
                handler(hasTokenGatedProductsValue) {
                    this.moduleInstance.toggleClass(hasTokenGatedProductsValue)
                },
                immediate: true
            }
        },

        methods: {
            setCartData(rawCart) {
                this.cart = rawCart
            }
        },
    });
}
